<nb-card>
	<nb-card-body>
		@if (!!form) {
			<form [formGroup]="form">
				<div class="pricing-adjustments">
					<div class="description">The system calculates the value based on the clients answers. You can manually overwrite it here.</div>
					@for (intermediatePriceAdjustment of intermediatePriceAdjustmentsSorted; track intermediatePriceAdjustment.type) {
						<div class="intermediate-price-adjustments">
							<div class="intermediate-price-adjustment-label">
								<span class="label">{{ intermediatePriceAdjustment | adjustmentName: standard() : product.accreditationBody }}</span>
							</div>
							<div class="intermediate-price-adjustment-values">
								<div class="chosen-value">{{ getChosenValueFor(intermediatePriceAdjustment) | riskName: "neuter" | async }}</div>
								<nb-radio-group id="adjustment-values" [name]="getRadioGroupName(intermediatePriceAdjustment)"
												[formControlName]="getControlNameFor(intermediatePriceAdjustment)" status="primary"
												(valueChange)="updateFormControl(getControlNameFor(intermediatePriceAdjustment), $event)">
									@for (adjustmentValue of intermediatePriceAdjustment.values; track adjustmentValue) {
										<nb-radio [id]="adjustmentValue"
												  [name]="getRadioBtnName(intermediatePriceAdjustment, adjustmentValue)"
												  [value]="adjustmentValue">
											{{ adjustmentValue | riskName: "neuter" | async }}
										</nb-radio>
									}
								</nb-radio-group>
							</div>
						</div>
					}

					<direct-price-adjustments
							[form]="form"
							[config$]="config$"
							[formService]="priceAdjustmentsFormService"
							[feesRateHint$]="feesRateHint$"
							[dailyRateControlName]="dailyRateFormControl()"
							[feesModeControlName]="feesModeControl()"
							[standard]="standard()"
							[preAuditRequested]="product.additionalQuestions.initialCertificationQuestions ? product.additionalQuestions.initialCertificationQuestions.preAuditRequested : false"
							[isTransfer]="isTransfer()">
					</direct-price-adjustments>
				</div>
			</form>
		}
	</nb-card-body>
</nb-card>
